<template>
    <div class="index">
        <!-- 导航栏 -->
        <div class="topNav">
            <div class="nav-box">
                <img class="nav-image" src="../../assets/index/logo.png">
                <span class="nav-title">山东省泰山教育创新研究院技能等级考试系统</span>
            </div>
        </div>

        <!-- 主页 -->
        <div class="index-view">
            <div class="index-search">
                <div class="search-title">考生登录</div>
                <div class="input-item">
                    <div class="name-view">姓名</div>
                    <div class="name-view-txt">:</div>
                    <input v-model="name" class="input-view" type="text" placeholder="请输入姓名" @input="changeName">
                    <div class="warn-view" v-if="nameRule == true">请填写姓名</div>
                </div>

                <div class="input-item input-item2">
                    <div class="name-view">准考证号</div>
                    <div class="name-view-txt">:</div>
                    <input v-model="number" class="input-view" type="text" placeholder="请输入准考证号" @input="changeNumber">
                    <div class="warn-view" v-if="numberRule == true">请填写准考证号</div>
                </div>
            </div>

            <!-- 考试按钮 -->
            <div class="button-view" @click="toExam">开始考试</div>

            <!-- 遮罩层弹窗 -->
            <div class="cover-box" v-if="coverShow == true">
                <div class="cover-box-item">
                    <p>未查询到该考生信息，请检查信息是否输入有误！</p>
                    <div class="close-button" @click="closeCover"></div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'index',
        data() {
            return {
                coverShow: false,
                name: '',
                number: '',
                nameRule: false,
                numberRule: false

            }
        },
        methods: {
            toExam() {
                if(this.name == '' || this.number == '') { 
                    if(this.name == '') {
                        this.nameRule = true 
                    }
                    if(this.number == '') {
                        this.numberRule = true
                    }
                } else  {
                    this.http.post('/exam/login', {
                        username: this.name,
                        examNo: this.number
                    }).then(res=> {
                        if(res.data.code == 0) {
                            localStorage.setItem('recordId', res.data.result.recordId)
                            localStorage.setItem('userId', res.data.result.userId)
                            this.$store.commit('setLoginInf')
                            this.$router.push('exam')
                        } else {
                            this.coverShow = true
                        }
                    }) 
                   
                }
               
               
            },
            changeName() {
                this.nameRule = false
            },
            changeNumber() {
                this.numberRule = false
            },
            openCover() {
                // this.http.get('/certificate/search?idCard=' + this.number).then(res => {
                   
                // }) 
            },
            closeCover() {
                this.coverShow = false
            }
        }
    }
</script>

<style lang="less" scoped>
    .index {
        width: 100%;
        min-height: 100vh;
        background: #368FCE;
        .topNav {
            width: 100%;
            height: 100px;
            background-color: #fff;
            .nav-box {
                width: 100%;
                padding: 20px 140px;
                box-sizing: border-box;
                display: flex;
                .nav-image {
                    width: 35px;
                    height: 35px;
                    margin-top: 8px;
                }
                .nav-title {
                    margin-left: 11px;
                    font-size: 36px;
                    font-weight: 500;
                    color: #368FCE;
                }
                
            }
        
        }
        .index-view {
            padding-top: 50px;
            box-sizing: border-box;
        }
        .index-search {
            width: 1200px;
            margin: 0 auto;
            background-color: #FFFFFF;
            border-radius: 15px;
            padding: 60px 81px 55px 102px;
            box-sizing: border-box;
            .search-title {
                font-size: 40px;
                font-weight: 500;
                color: #333333;
                text-align: center;
            }
            .input-item {
                width: 100%;
                display: flex;
                margin-top: 45px;
                margin-bottom: 100px;
                position: relative;
                .name-view {
                    width: 150px;
                    font-size: 30px;
                    font-weight: 500;
                    color: #333333;
                    line-height: 80px;
                    text-align-last: justify;
                }
                .input-view {
                    margin-left: 50px;
                    width: 792px;
                    height: 80px;
                    border-radius: 8px;
                    border: 3px solid #333333;
                    padding: 0 30px;
                    font-size: 30px;
                    font-weight: 500;
                    color: #333333;
                }
                input::-webkit-input-placeholder {
                    color: #D8D8D8;
                }
                .warn-view {
                    position: absolute;
                    top: 100px;
                    left: 230px;
                    font-size: 26px;
                    font-weight: 500;
                    color: #E02020;
                }
                .name-view-txt {
                    font-size: 28px;
                    font-weight: 500;
                    color: #333333;
                    line-height: 63px;
                    margin-left: 10px;
                    margin-top: 10px;
                }
                
            }
            
            
        }
        .button-view {
            margin: 0 auto;
            margin-top: 40px;
            width: 1200px;
            height: 120px;
            background: #FFFFFF;
            border-radius: 15px;
            font-size: 40px;
            font-weight: 500;
            color: #368FCE;
            line-height: 120px;
            text-align: center;
            cursor: pointer;
        }


        .cover-box {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.45);
            z-index: 999;
            .cover-box-item {
                width: 700px;
                background: #FFFFFF;
                border-radius: 15px;
                margin: 0 auto;
                margin-top: 250px;
                padding: 40px 60px;
                box-sizing: border-box;
                position: relative;
                
                .close-button {
                    position: absolute;
                    width: 68px;
                    height: 68px;
                    background-image: url('../../assets/index/close.png');
                    background-size: 100% 100%;
                    top: -86px;
                    right: -86px;
                    cursor: pointer;
                }
            }
            
            
        } 
    }
</style>